import { StyledResult } from './styles';

interface ErrorMessageProps {
  text: string;
}

export function ErrorMessage({ text }: ErrorMessageProps) {
  return <StyledResult status="error" title="Ошибка" subTitle={text} />;
}
